import { Color } from './color';
/**
 * ▽
 */
export const HollowTriangleDown = (options, context) => {
    return Color(Object.assign({ colorAttribute: 'stroke', symbol: 'triangle-down' }, options), context);
};
HollowTriangleDown.props = Object.assign({ defaultMarker: 'hollowTriangleDown' }, Color.props);
//# sourceMappingURL=hollowTriangleDown.js.map